import { VesselMessage } from '../../../../types/VesselMessage';

import { RegularScheduleSection } from './RegularScheduleSection';

interface ScheduleSectionProps {
    vessel: VesselMessage;
}

export const ScheduleSection = (props: ScheduleSectionProps) => {
    return <RegularScheduleSection vessel={props.vessel} />;
};
